/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 9/1/13
 * Time: 4:44 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var template = require("ui/dropdown/templates/dropdownItem.tmpl");

    var ACTIVE_CSS_CLASS = "active"; //the css class that's used for marking an item as active.
    var SELECTED_CSS_CLASS = "selected"; //the css class that's used for marking an item as selected.

    var DropdownItemView = Marionette.ItemView.extend({
        template : template,
        tagName : "li",
        triggers: {
            "click": "itemClick"
        },
        events: {
            "mouseover":"_onItemMouseOver"
        },
        ui : {
            icon : ".dropdown-li-icon",
            value : ".dropdown-li-value"
        },
        modelEvents: {
            "change:value":"_onValueChange",
            "change:icon":"_onIconChange",
            "change:cssClass":"_onCssClassChange"
        },


        initialize: function (options) {
            this.itemIndex = options.itemIndex;
        },
        /**
         * Add some attributes after the li  HTML element rendered.
         */
        onRender: function () {
            this.ui.value.addClass(this.model.get("cssClass"));
            this.$el.attr("data-key", this.model.get("key"));
            this.$el.attr("data-value", this.model.get("value"));
            this.$el.attr("data-icon", this.model.get("icon"));
            this._setTooltip();
        },

        _onItemMouseOver: function(){
            // event used to be directly under trigger, this is a workaround - not to collide the tooltip operations
            this.trigger("itemMouseOver");
        },

        _setTooltip: function(){
            if (this.model.get("title") !== ""){
                this.$el.attr("title", this.model.get("tooltipTitle"));
            }
            if (this.model.get("align") !== ""){
                this.$el.attr("tooltip-position", this.model.get("tooltipPosition"));
            }
        },

        _onValueChange: function() {
            this.ui.value.text(this.model.get("value"));
        },

        /**
         * NOTE: we aggregate the icon classes on the relevant HTML element.
         * Currently this functionality is not in use so we dont know the proper and correct functionality to use.
         * @private
         */
        _onIconChange: function() {
            this.ui.icon.addClass(this.model.get("icon"));
            this.$el.attr("data-icon", this.model.get("icon"));
        },

        /**
         * NOTE: we aggregate the classes on the relevant HTML element.
         * Currently this functionality is not in use so we dont know the proper and correct functionality to use.
         * @private
         */
        _onCssClassChange: function() {
            this.ui.value.addClass(this.model.get("cssClass"));
        },

        getIconHTMLElement: function() {
            return this.ui.icon.clone();
        },

        getValueHTMLElement: function() {
            return this.ui.value.clone();
        },

        setActive: function(state) {
            this.$el.toggleClass(ACTIVE_CSS_CLASS, state);
        },

        setSelected: function(state) {
            this.$el.toggleClass(SELECTED_CSS_CLASS, state);
        }
    });

    return DropdownItemView;
});